var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{attrs:{"role":"banner"}},[_c('div',{staticClass:"brand"},[(!_vm.partnerLogo)?_c('h1',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.partnerName)}})]):_c('img',{staticClass:"brand__img",attrs:{"alt":_vm.partnerName,"src":_vm.partnerLogo}})])]),_vm._v(" "),_c('main',{attrs:{"role":"main"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }